import { render, staticRenderFns } from "./configurar_widgets.vue?vue&type=template&id=45db783f&"
import script from "./configurar_widgets.vue?vue&type=script&lang=js&"
export * from "./configurar_widgets.vue?vue&type=script&lang=js&"
import style0 from "./configurar_widgets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports